import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags'
import React, { useState, useRef } from 'react'
import './styles.css'

import { Row, Col, Alert, Label } from 'reactstrap'
import { Link, Redirect } from 'react-router-dom'
import { Mail, Lock, Eye, EyeOff } from 'react-feather'

import { AvForm, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation'

import { loginUser } from '../../store/actions'

import { useUserInfo } from 'context/userContext'
import { AuthSplitShell } from './AuthSplitShell'

const Login = () => {
  const { setUserName } = useUserInfo()
  const [login, setLogin] = useState(false)
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const submitLock = useRef(false)

  const handleValidSubmit = async (event, values) => {
    if (submitLock.current) return
    submitLock.current = true
    setSubmitting(true)
    try {
      const result = await loginUser(values)
      if (result.status === 200) {
        setError(false)
        setMessage('')
        setUserName(result.userName)
        setLogin(true)
      } else {
        setLogin(false)
        setError(true)
        setMessage(result.message)
      }
    } finally {
      submitLock.current = false
      setSubmitting(false)
    }
  }

  if (login) {
    return <Redirect to="/dashboard" />
  }

  return (
    <>
      <MetaTags>
        <title>Login | Zap+</title>
      </MetaTags>
      <AuthSplitShell
        mode="signin"
        title={
          <>
            Campanhas e disparos,{' '}
            <span className="auth-split__accent">simplificados</span>.
          </>
        }
        subtitle="Entre com sua conta para continuar."
      >
        <div className="auth-split__form-card">
          <AvForm
            className="auth-dark__form"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            {error && (
              <Alert color="danger" className="auth-dark__alert mb-3">
                {message}
              </Alert>
            )}
            <fieldset
              disabled={submitting}
              className="auth-split__fieldset"
            >
            <Row className="g-3">
              <Col xs={12}>
                <AvGroup>
                  <Label className="auth-split__label" for="login-email">
                    E-mail
                  </Label>
                  <div className="auth-split__input-wrap">
                    <Mail className="auth-split__input-icon" size={18} aria-hidden />
                    <AvInput
                      id="login-email"
                      name="email"
                      type="email"
                      placeholder="seu@email.com"
                      required
                      className="form-control auth-dark__control auth-split__control-inset"
                    />
                  </div>
                  <AvFeedback>E-mail inválido</AvFeedback>
                </AvGroup>
              </Col>
              <Col xs={12}>
                <AvGroup>
                  <Label className="auth-split__label" for="login-password">
                    Senha
                  </Label>
                  <div className="auth-split__input-wrap auth-split__input-wrap--password">
                    <Lock className="auth-split__input-icon" size={18} aria-hidden />
                    <AvInput
                      id="login-password"
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      placeholder="••••••••"
                      required
                      className="form-control auth-dark__control auth-split__control-inset auth-split__control-password"
                    />
                    <button
                      type="button"
                      className="auth-split__pw-toggle"
                      aria-label={
                        showPassword ? 'Ocultar senha' : 'Mostrar senha'
                      }
                      onClick={() => setShowPassword((v) => !v)}
                    >
                      {showPassword ? (
                        <EyeOff size={18} aria-hidden />
                      ) : (
                        <Eye size={18} aria-hidden />
                      )}
                    </button>
                  </div>
                  <AvFeedback>Informe a senha</AvFeedback>
                </AvGroup>
              </Col>
            </Row>

            {/* <div className="auth-split__row-between mt-2">
              <label className="auth-split__remember">
                <input type="checkbox" />
                <span>Lembrar-me</span>
              </label>
              <Link to="/forgot-password" className="auth-split__forgot">
                Esqueceu a senha?
              </Link>
            </div> */}

            <button
              type="submit"
              className="btn auth-dark__btn-primary auth-dark__btn-primary--with-spinner w-100 mt-4"
              aria-busy={submitting}
            >
              {submitting ? (
                <>
                  <span className="auth-btn-spinner" aria-hidden />
                  Entrando…
                </>
              ) : (
                'Entrar'
              )}
            </button>
            </fieldset>
          </AvForm>
        </div>
      </AuthSplitShell>
    </>
  )
}

export default Login

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func
}
